import FormFileService from '../Service/FormFileService'

const formFileService = new FormFileService()
formFileService.init()
